module.exports = __webpack_public_path__ + "static/media/gates-of-hell.61f3c7ec.gif";